import {
  createHTTP,
  HTTPEndpointInput,
  HTTPRequestJSONOptions,
} from '@superdispatch/http';
import { URITemplateParams } from '@superdispatch/uri';
import { APIPageResponse, APIResponse } from 'shared/api/CarrierAPIClient';
import { getAuthToken, getCarrierGuid } from 'shared/auth/AuthToken';
import { FRAUD_MONITOR_HOST } from 'shared/constants/ServerConstants';

function getFraudMonitorRequestHeaders(headers: Record<string, string> = {}) {
  headers = { ...headers };

  if (!headers.authorization) {
    const token = getAuthToken();
    if (token) {
      headers.authorization = `Token ${token}`;
    }
  }

  const carrierGuid = getCarrierGuid();
  if (carrierGuid) {
    headers['X-Carrier-Guid'] = carrierGuid;
  }

  return headers;
}

const fraudMonitorHttpClient = createHTTP({
  baseURL: FRAUD_MONITOR_HOST,
  headers(headers) {
    return getFraudMonitorRequestHeaders(headers as Record<string, string>);
  },
});

export function requestFraudMonitorAPI<
  TData extends APIResponse,
  TParams extends URITemplateParams = URITemplateParams,
>(
  input: HTTPEndpointInput<TParams>,
  options?: Omit<HTTPRequestJSONOptions<TData>, 'baseURL'>,
): Promise<TData> {
  return fraudMonitorHttpClient.requestJSON(input, options);
}

export function mapFraudMonitorAPIPageToCarrierAPIPage<TData>({
  data,
  pagination,
}: APIPageResponse<TData>): APIPageResponse<TData> {
  return {
    data,
    pagination,
    meta: { request_id: '', code: 200 },
    user_message: '',
  };
}
